// import Immutable from "immutable";

import { USER_SELECTS_PRIMARY_FILTER_TYPE, USER_SELECTS_PRIMARY_OPTIONS } from "../actions/primary_filter";

import {
  USER_SELECTS_SECONDARY_AREA_FILTER_TYPE,
  USER_SELECTS_SECONDARY_AREA_OPTION,
  USER_SELECTS_SECONDARY_CATEGORY_FILTER_TYPE,
  USER_SELECTS_SECONDARY_CATEGORY_OPTION,
} from "../actions/secondary_filters";

import { USER_SELECTS_VIEW_TYPE } from "../actions/view_type";
import { USER_SELECTS_REPORT_BOOK } from "../actions/report_book";

const initialState = { primaryFilter: {}, viewType: {}, secondaryFilters: {} };

const filterReducer = (state = initialState, action) => {
  let tempFilter;

  switch (action.type) {
  case USER_SELECTS_PRIMARY_FILTER_TYPE:
    tempFilter = {
      primaryFilter: { selectedTypeId: action.payload && action.payload.id },
      viewType: { id: action.payload && action.payload.default_view },
      secondaryFilters: {}
    };
    return Object.assign({}, state, tempFilter);
  case USER_SELECTS_PRIMARY_OPTIONS:
    tempFilter = Object.assign({}, state.primaryFilter, { selectedOptions: action.payload });
    return Object.assign({}, state, { primaryFilter: tempFilter });
  case USER_SELECTS_VIEW_TYPE:
    tempFilter = { viewType: { id: action.payload }, secondaryFilters: {} };
    return Object.assign({}, state, tempFilter);
  case USER_SELECTS_SECONDARY_AREA_FILTER_TYPE:
    tempFilter = Object.assign({}, state.secondaryFilters, { areaTypeId: action.payload, areaOption: [] });
    return Object.assign({}, state, { secondaryFilters: tempFilter });
  case USER_SELECTS_SECONDARY_AREA_OPTION:
    tempFilter = Object.assign({}, state.secondaryFilters, { areaOption: action.payload });
    return Object.assign({}, state, { secondaryFilters: tempFilter });
  case USER_SELECTS_SECONDARY_CATEGORY_FILTER_TYPE:
    tempFilter = Object.assign({}, state.secondaryFilters, { categoryTypeId: action.payload, categoryOption: [] });
    return Object.assign({}, state, { secondaryFilters: tempFilter });
  case USER_SELECTS_SECONDARY_CATEGORY_OPTION:
    tempFilter = Object.assign({}, state.secondaryFilters, { categoryOption: action.payload });
    return Object.assign({}, state, { secondaryFilters: tempFilter });
  case USER_SELECTS_REPORT_BOOK:
    tempFilter = {
      primaryFilter: { selectedTypeId: action.payload.defaultPrimaryFilter },
      viewType: { id: action.payload.defaultView },
      secondaryFilters: {},
      reportBook: action.payload.value
    };
    return Object.assign({}, state, tempFilter);
  default:
    return state;
  }
};

export default filterReducer;
